import { formatDateLocale } from 'CorePackage/MainModule/common/formatDate';

import { ISubjectNotification } from '../../../APIPackage/KnmSearchModule/interfaces/ISubjectNotification';
import { KnmSubtitle } from './KnmSubtitle';
import styles from './KnmPreview.module.scss';
import { convertArrayToDate } from '../common/convertArrayToDate';
import {
  DATE_FORMAT_LONG_FNS,
  SYSTEM_DATE_FORMAT_SHORT_FNS,
} from '../../../CorePackage/MainModule/constants/dateFormats';

interface ISubjectNotificationsProps {
  subjectNotifications: ISubjectNotification[] | undefined;
  isPm?: boolean;
}

export const SubjectNotifications = ({ subjectNotifications, isPm }: ISubjectNotificationsProps) => {
  if (!subjectNotifications || subjectNotifications.length === 0) {
    return null;
  }

  return (
    <KnmSubtitle title={`Информация об уведомлении проверяемого лица о проведении ${isPm ? 'ПМ' : 'КНМ'}`}>
      {subjectNotifications.map((item, index) => (
        <div key={index}>
          <div className={styles.SectionTitle}>Уведомление #{index + 1}</div>
          {item.type?.name && (
            <div className={styles.Row}>
              <div className={styles.ColText}>Способ уведомления</div>
              <div className={styles.ColValue}>{item.type.name}</div>
            </div>
          )}
          {item.date && (
            <div className={styles.Row}>
              <div className={styles.ColText}>Дата уведомления</div>
              <div className={styles.ColValue}>
                {formatDateLocale({
                  date: convertArrayToDate(item.date),
                  dateFormat: DATE_FORMAT_LONG_FNS,
                  parseFormat: SYSTEM_DATE_FORMAT_SHORT_FNS,
                })}
              </div>
            </div>
          )}
          {item.comment && (
            <div className={styles.Row}>
              <div className={styles.ColText}>Примечание</div>
              <div className={styles.ColValue}>{item.comment}</div>
            </div>
          )}
        </div>
      ))}
    </KnmSubtitle>
  );
};
